export default "__VITE_ASSET__wEcpB23q__"